function import_all( r ) {
	r.keys().forEach( r );
}

import_all( require.context( './', true, /\.js$/ ) );

setTimeout(function () {
	// Give chance to load if already installed and check if the custom element has been registered if not include the lite-vimeo library
	if ( customElements.get( 'lite-vimeo' ) === undefined ) {
		require( '@slightlyoff/lite-vimeo' );
	}
}, 1000 );
